export const MOCK_API_CONFIG = {
  isBrandSwitched: false,
  locationEnabled: false,
  gqlWarnThreshold: 10000,
  GRAPHQL_CLIENT_CACHE_CLEAR_INTERVAL: 15,
  GRAPHQL_API_TIMEOUT: '15000',
  GRAPHQL_API_TIMEOUT_CLIENT: '30000',
  graphql_auth_type: 'API_KEY',
  graphql_api_key: '',
  langId: '-1',
  storeId: '10151',
  isUSStore: true,
  countryKey: '_US',
  siteId: 'us',
  siteIdCMS: 'USA',
  locale: 'en_US',
  brandId: 'tcp',
  brandIdCMS: 'TCP',
  catalogId: '10551',
  country: 'US',
  currency: 'USD',
  hostname: 'www.childrensplace.com',
  language: 'en',
  originalPath: '/us/home',
  reqHostname: 'www.childrensplace.com',
  isPreviewEnv: false,
  isAppChannel: false,
  isMobile: false,
  cookie: null,
  isCSREnabledForHome: true,
};

export const FETCH_POLICY = {
  SAME_ORIGIN: 'same-origin',
  NETWORK_ONLY: 'network-only',
};

export const CONTEXT = 'product-page';
export const TOP_PRODUCTS_TCP_PRODUCT_PAGE = 'top-products-tcp-product-page';
export const TOP_PRODUCTS_TCP_US = 'top-products-tcp-us';

export const TOP_PRODUCTS_VARIABLES = {
  first: 2,
};
